module.exports = __webpack_public_path__ + "img/mesa_d113.d515f6be.png";